import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment/moment';

@Pipe({name: 'formattedDate', pure: true})
export class FormattedDatePipe implements PipeTransform {
  transform(value: string): string {
    const date = moment.utc(value, 'YYYY-MM-DDTHH:mm:ssZ', true);
    return date.format('MM/DD/YYYY hh:mm');
  }
}
